import { useMemo } from 'react';

/**
 * hook returns years options based on offset passed,
 * it double the offset to get +/- offset results starting from current year
 *
 * @param {{ offset: number }}
 * @return { YEARS_OPTIONS } { value: number, label: string }
 */
function useGetYearsOptions({ offset }) {
    const offsetYear = new Date().getFullYear() - offset;
    const yearsOptions = useMemo(() => Array.from({ length: offset * 2 + 1 }).map((_, index) => ({
        value: offsetYear + index,
        label: (offsetYear + index).toString(),
    })), [offsetYear, offset]);
    return { yearsOptions };
}

export { useGetYearsOptions };
//# sourceMappingURL=useGetYearsOptions.js.map
